import { Component, OnInit, Injector, ElementRef, ViewChild, AfterContentChecked, ViewChildren } from '@angular/core';
import { WorkOrdersService } from '../../../work-orders.service';
import { FilterableService } from '../../../../filterable-service';
import { WorkOrderFileUploadComponent } from '../../../work-order-file-upload/work-order-file-upload.component';
import {
  StudyTitlesService,
  ProgramDetailsGAService,
  PlantService,
  GateService,
  CMEAreaService,
  SmtService,
  AuthorizationService,
  DocumentService
} from '../../../../ve.service';

const ACTIVE_ONLY_REQUEST = '?activeOnly=true';
const ALL_REQUEST = '?activeOnly=false';

@Component({
  selector: 'ga-main-form',
  templateUrl: './ga-main-form.component.html',
  styleUrls: [
    '../../../work-orders.component.scss',
    './ga-main-form.component.scss'
  ]
})
export class GaMainFormComponent extends WorkOrderFileUploadComponent implements OnInit, AfterContentChecked {
  @ViewChild('printContainer', {static: true}) private readonly printContainerRef: ElementRef;

  printFormData = {
    Requestor: {
      Name: ''
    },
    Description: '',
    Architecture: '',
    AssignedEngineerName: '',
    RequiredDate: '',
    Gate: {
      Description: ''
    },
    GateTargeted: {
      Name: ''
    },
    StudyInstructions: '',
    ProgramCode: '',
    Plant: {
      PlantDescription: ''
    },
    SMT1Description: {
      Description: ''
    },
    SMT2Description: {
      Description: ''
    },
    SMT3Description: {
      Description: ''
    },
    ErgorEngineerName: '',
    VeLeadName: '',
    MeLeadName: '',
    ME: {
      Name: ''
    },
    CMEArea: {
      Description: ''
    }
  };

  workOrdersService: WorkOrdersService;
  studyTitlesService: StudyTitlesService;
  programDetailsService: ProgramDetailsGAService;
  plantService: PlantService;
  gateService: GateService;
  cmeAreaService: CMEAreaService;
  smtService: SmtService;
  authService: AuthorizationService;
  documentService: DocumentService;

  studyTitlesList = new FilterableService();
  programsList = new FilterableService();
  plantList = new FilterableService();
  gateList = new FilterableService();
  cmeAreaList = new FilterableService();
  allSMTs = new FilterableService();
  smt1List = new FilterableService();
  smt2List = new FilterableService();
  smt3List = new FilterableService();
  usersList = new FilterableService();
  documentTypesService = new FilterableService();
  documentsService = new FilterableService();

  architecture: any;
  ergoEngineer: any;
  veLead: any;
  meLead: any;
  gateTargeted: any;
  isOtherStudyTitle = false;
  defaultCMEArea: any;
  defaultSMT1: any;
  defaultSMT2: any;
  defaultSMT3: any;

  constructor(injector: Injector) {
    super(injector);
    this.workOrdersService = injector.get(WorkOrdersService);
    this.studyTitlesService = injector.get(StudyTitlesService);
    this.programDetailsService = injector.get(ProgramDetailsGAService);
    this.plantService = injector.get(PlantService);
    this.gateService = injector.get(GateService);
    this.cmeAreaService = injector.get(CMEAreaService);
    this.smtService = injector.get(SmtService);
    this.authService = injector.get(AuthorizationService);
    this.documentService = injector.get(DocumentService);
  }

  ngOnInit() {
    this.setRequestDate();
    this.getGateTargeted();

    this.fileUploadService.uploadSaveUrl = this.documentService.getUploadUrl('VE_GA', false);
    this.fileUploadService.fileType = 'Instructions';
    this.fileUploadService.workOrderId = this.workOrdersService.workOrderDetailsForm.get('Id').value;

    Promise.all([
      this.getStudyTitles(),
      this.getPrograms(),
      this.getGates(),
      this.getCMEAreas(),
      this.getSMT1s(),
      this.getContacts(),
      this.fileUploadService.getFiles()
    ]).then(() => {
      this.setOtherField();
      if (!this.workOrdersService.isNewWO || this.workOrdersService.isCopyWO) { this.getEditData(); }
    });
  }

  ngAfterContentChecked() {
    this.setPrintData();
  }

  setOtherField() {
    const currentStudyTitleId = this.workOrdersService.workOrderDetailsForm.get('StudyTitleId').value;
    const studyTitle = this.studyTitlesList.value.find(x => x.Id === currentStudyTitleId);
    if (studyTitle && studyTitle.Description === 'Other') {
      this.isOtherStudyTitle = true;
    }
  }

  isOtherStudyTitleEnabled() {
    return this.isOtherStudyTitle;
  }

  getEditData() {
    const programDetailsId = this.workOrdersService.editData.ProgramDetailId;
    const studyTitleId = this.workOrdersService.editData.StudyTitleId;
    this.onProgramChange(programDetailsId, true);
    this.onStudyTitleChange(studyTitleId, true);
  }

  getStudyTitles(): Promise<any> {
    return this.studyTitlesService.read(this.workOrdersService.isViewOnlyWO ? ALL_REQUEST : ACTIVE_ONLY_REQUEST)
      .then(response => {
        response = response.sort((a, b) => a.Description.localeCompare(b.Description));
        this.studyTitlesList.next(response);
      });
  }

  setRequestDate() {
    const date = new Date();
    this.workOrdersService.workOrderDetailsForm.get('RequestDate').setValue(date);
  }

  getPrograms(): Promise<any> {
    return this.programDetailsService.read(this.workOrdersService.isViewOnlyWO ? ALL_REQUEST : ACTIVE_ONLY_REQUEST)
      .then(response => {
        response = response.sort((a, b) => a.ProgramCode.localeCompare(b.ProgramCode));
        this.programsList.next(response);
      });
  }

  getPlants(programId: any): Promise<any> {
    return this.plantService.read('ByProgram/' + programId)
      .then(response => {
        if (!response) { return; }
        response = response.sort((a, b) => a.PlantDescription.localeCompare(b.PlantDescription));
        this.plantList.next(response);
      });
  }

  getGates(): Promise<any> {
    return this.gateService.read(this.workOrdersService.isViewOnlyWO ? ALL_REQUEST : ACTIVE_ONLY_REQUEST)
      .then(response => {
        this.gateList.next(response);
      });
  }

  getCMEAreas(): Promise<any> {
    return this.cmeAreaService.read(this.workOrdersService.isViewOnlyWO ? ALL_REQUEST : ACTIVE_ONLY_REQUEST)
      .then(response => {
        this.cmeAreaList.next(response);
      });
  }

  getSMT1s(): Promise<any> {
    const smt1s: any[] = [];

    return this.smtService.read(this.workOrdersService.isViewOnlyWO ? ALL_REQUEST : ACTIVE_ONLY_REQUEST)
      .then(response => {
        response.forEach(smt => {
          if (smt.SMTReferenceId == null) { smt1s.push(smt); }
        });

        smt1s.sort((a, b) => a.Description.localeCompare(b.Description));
        this.smt1List.next(smt1s);
        this.allSMTs.next(response);
      });
  }

  getSMT2s(smtParentId: any[]): Promise<any> {
    return this.smtService.read('/smtchildren/' + smtParentId)
      .then(response => {
        response = response.sort((a, b) => a.Description.localeCompare(b.Description));
        this.smt2List.next(response);
      });
  }

  getSMT3s(smtParentId: any[]): Promise<any> {
    return this.smtService.read('/smtchildren/' + smtParentId)
      .then(response => {
        response = response.sort((a, b) => a.Description.localeCompare(b.Description));
        this.smt3List.next(response);
      });
  }

  getContacts(): Promise<any> {
    return this.authService.read('/moduleusers?moduleName=VE_GA')
      .then(response => {
        response = response.sort((a, b) => a.Name.localeCompare(b.Name));
        this.usersList.next(response);
      });
  }

  getGateTargeted() {
    this.gateTargeted = [
      {
        Name: 'Yes',
        Value: true
      },
      {
        Name: 'No',
        Value: false
      }
    ];
  }

  getProgramRelatedFields(programDetailsId: any, firstRender: boolean): Promise<any> {
    if (programDetailsId) {
      return this.programDetailsService.read('/' + programDetailsId)
        .then(response => {
          if (!response) { return; }
          this.printFormData = { ...this.printFormData, ...response };
          this.getPlants(response.ProgramId);
          this.setProgram(response);
          this.setArchitecture(response);
          this.setErgoEngineer(response, firstRender);
          this.setVELead(response, firstRender);
          this.setMELead(response, firstRender);
        });
    }
    return null;
  }

  onStudyTitleChange(event: any, firstRender: boolean): Promise<any> {
    const studyTitleId = event;
    if (!studyTitleId) {
      this.isOtherStudyTitle = false;
      this.workOrdersService.workOrderDetailsForm.get('OtherStudyName').reset();
      this.workOrdersService.workOrderDetailsForm.get('CMEAreaId').reset();
      this.workOrdersService.workOrderDetailsForm.get('ME').reset();
      this.workOrdersService.workOrderDetailsForm.get('SMT1Id').reset();
      this.workOrdersService.workOrderDetailsForm.get('SMT2Id').reset();
      this.workOrdersService.workOrderDetailsForm.get('SMT3Id').reset();
      return null;
    } else {
      return this.studyTitlesService.read('/' + studyTitleId)
        .then(response => {
          if (!response) {
            return;
          }
          if (!firstRender) {
            this.isOtherStudyTitle = response.Description === 'Other';

            this.defaultCMEArea = this.cmeAreaList.value.find(x => x.Id === response.CMEAreaId);
            this.workOrdersService.workOrderDetailsForm.get('CMEAreaId').setValue(this.defaultCMEArea.Id);
            this.workOrdersService.workOrderDetailsForm.get('ME').setValue(this.defaultCMEArea.ME);

            this.defaultSMT1 = this.allSMTs.value.find(x => x.Id === response.SMT1Id);
            this.workOrdersService.workOrderDetailsForm.get('SMT1Id').setValue(this.defaultSMT1.Id);

            this.getSMT2s(response.SMT1Id);
            this.defaultSMT2 = this.allSMTs.value.find(x => x.Id === response.SMT2Id);
            this.workOrdersService.workOrderDetailsForm.get('SMT2Id').setValue(this.defaultSMT2.Id);

            this.getSMT3s(response.SMT2Id);
            this.defaultSMT3 = this.allSMTs.value.find(x => x.Id === response.SMT3Id);
            this.workOrdersService.workOrderDetailsForm.get('SMT3Id').setValue(this.defaultSMT3.Id);
          } else {
            const smt1Id = this.workOrdersService.workOrderDetailsForm.get('SMT1Id').value;
            const smt2Id = this.workOrdersService.workOrderDetailsForm.get('SMT2Id').value;
            const cmeAreaId = this.workOrdersService.workOrderDetailsForm.get('CMEAreaId').value;
            this.onSMT1Selection(smt1Id, firstRender);
            this.onSMT2Selection(smt2Id, firstRender);
            this.onCMEAreaChange(cmeAreaId, firstRender);
          }

          this.printFormData = { ...this.printFormData, ...response };
        });
    }
  }

  onProgramChange(event: any, firstRender: boolean): Promise<any> {
    if (!firstRender) {
      this.clearProgramRelatedFields();
    }
    const programDetailsId = event;
    return this.getProgramRelatedFields(programDetailsId, firstRender);
  }

  onSMT1Selection(event: any, firstRender: boolean) {
    const smtParentId = event;
    if (!firstRender) {
      this.workOrdersService.workOrderDetailsForm.get('SMT2Id').setValue(null);
      this.workOrdersService.workOrderDetailsForm.get('SMT3Id').setValue(null);
    }

    if (!smtParentId) {
      this.smt2List.next(null);
      this.smt3List.next(null);
    } else {
      this.getSMT2s(smtParentId);
    }
  }

  onSMT2Selection(event: any, firstRender: boolean) {
    const smtParentId = event;
    if (!firstRender) {
      this.workOrdersService.workOrderDetailsForm.get('SMT3Id').setValue(null);
    }

    if (!smtParentId) {
      this.smt3List.next(null);
    } else {
      this.getSMT3s(smtParentId);
    }
  }

  onCMEAreaChange(event: any, firstRender: boolean) {
    if (!event && !firstRender) {
      this.workOrdersService.workOrderDetailsForm.get('ME').reset();
    } else {
      this.defaultCMEArea = this.cmeAreaList.value.find(x => x.Id === event);
      if (!firstRender) {
        this.workOrdersService.workOrderDetailsForm.get('ME').setValue(this.defaultCMEArea.ME);
      }
    }
  }

  setProgram(response: any) {
    if (response.ProgramId) {
      this.workOrdersService.workOrderDetailsForm.get('ProgramId').setValue(response.ProgramId);
    }
  }

  setArchitecture(response: any) {
    if (response.ArchitectureId) {
      this.architecture = response.ArchitectureDescription;
      this.workOrdersService.workOrderDetailsForm.get('ArchitectureId').setValue(response.ArchitectureId);
    } else {
      this.architecture = 'None';
    }
  }

  setErgoEngineer(response: any, firstRender: boolean) {
    const woDetailsFormErgoEngineer = this.workOrdersService.workOrderDetailsForm.get('ErgoEngineer').value;
    if (response.ErgoEngineer && woDetailsFormErgoEngineer !== null && !firstRender) {
      this.ergoEngineer = response.ErgorEngineerName;
      this.workOrdersService.workOrderDetailsForm.get('ErgoEngineer').setValue(response.ErgoEngineer);
    } else if (response.ErgoEngineer && woDetailsFormErgoEngineer !== null && firstRender) {
      const ergoEngineerGmin = this.workOrdersService.workOrderDetailsForm.get('ErgoEngineer').value;
      const ergoEngineerName = this.usersList.value.find(x => x.Gmin === ergoEngineerGmin);
      this.ergoEngineer = ergoEngineerName.Name;
    } else {
      this.ergoEngineer = 'None';
    }
  }

  setVELead(response: any, firstRender: boolean) {
    if (response.VELead && !firstRender) {
      this.veLead = response.VELeadName;
      this.workOrdersService.workOrderDetailsForm.get('VELead').setValue(response.VELead);
    } else if (response.VELead && firstRender) {
      const veLeadGmin = this.workOrdersService.workOrderDetailsForm.get('VELead').value;
      const veLeadName = this.usersList.value.find(x => x.Gmin === veLeadGmin);
      this.veLead = veLeadName.Name;
    } else {
      this.veLead = 'None';
    }
  }

  setMELead(response: any, firstRender: boolean) {
    if (response.MELead && !firstRender) {
      this.meLead = response.MELeadName;
      this.workOrdersService.workOrderDetailsForm.get('MELead').setValue(response.MELead);
    } else if (response.MELead && firstRender) {
      const meLeadGmin = this.workOrdersService.workOrderDetailsForm.get('MELead').value;
      const meLeadName = this.usersList.value.find(x => x.Gmin === meLeadGmin);
      this.meLead = meLeadName.Name;
    } else {
      this.meLead = 'None';
    }
  }

  clearProgramRelatedFields() {
    this.architecture = null;
    this.ergoEngineer = null;
    this.veLead = null;
    this.meLead = null;
    this.plantList.next(null);

    this.workOrdersService.workOrderDetailsForm.get('ArchitectureId').setValue(null);
    this.workOrdersService.workOrderDetailsForm.get('ErgoEngineer').setValue(null);
    this.workOrdersService.workOrderDetailsForm.get('VELead').setValue(null);
    this.workOrdersService.workOrderDetailsForm.get('MELead').setValue(null);
    this.workOrdersService.workOrderDetailsForm.get('PlantId').setValue(null);
  }

  public setPrintData() {
    // Setting print data from form field values. If reactive form has not finished loading, an empty string is assigned to print value.
    this.printFormData.Architecture = (this.architecture) ? this.architecture : '';
    this.printFormData.ErgorEngineerName = (this.ergoEngineer) ? this.ergoEngineer : '';
    this.printFormData.VeLeadName = (this.veLead) ? this.veLead : '';
    this.printFormData.MeLeadName = (this.meLead) ? this.meLead : '';
    this.setAssignedEngineerName();
    this.setPrintDataRequiredDate();
    this.setPrintDataRequestor();
    this.setPrintDataGate();
    this.setPrintDataGateTargeted();
    this.setPrintDataPlant();
    this.setPrintDataCMEArea();
    this.setPrintDataSMT1();
    this.setPrintDataSMT2();
    this.setPrintDataSMT3();
    this.setPrintDataME();
    this.setPrintDataStudyInstructions();
  }

  public setPrintDataRequiredDate() {
    this.printFormData.RequiredDate = (this.workOrdersService.workOrderDetailsForm.get('RequiredDate').value &&
      this.workOrdersService.workOrderDetailsForm.get('RequiredDate').value !== '') ?
      this.workOrdersService.workOrderDetailsForm.get('RequiredDate').value.toDateString() : '';
  }

  public setAssignedEngineerName() {
    this.printFormData.AssignedEngineerName = (this.workOrdersService.workOrderDetailsForm.get('AssignedEngineerName').value) ?
      this.workOrdersService.workOrderDetailsForm.get('AssignedEngineerName').value
      : 'Not Assigned...';
  }

  public setPrintDataRequestor() {
    const requestorFormField = this.workOrdersService.workOrderDetailsForm.get('Requestor');
    this.printFormData.Requestor = (requestorFormField && requestorFormField.value && this.usersList &&
      this.usersList.value && typeof this.usersList.value.find !== 'undefined') ?
      this.usersList.value.find(x => x.Gmin === requestorFormField.value) : '';
  }

  public setPrintDataGate() {
    const gateIdFormField = this.workOrdersService.workOrderDetailsForm.get('GateId');
    this.printFormData.Gate = (gateIdFormField && gateIdFormField.value && this.gateList &&
      this.gateList.value && typeof this.gateList.value.find !== 'undefined') ?
      this.gateList.value.find(x => x.Id === gateIdFormField.value) : '';
  }

  public setPrintDataGateTargeted() {
    const gateTargetedFormField = this.workOrdersService.workOrderDetailsForm.get('GateTargeted');
    this.printFormData.GateTargeted = (gateTargetedFormField && gateTargetedFormField.value &&
      this.gateTargeted && typeof this.gateTargeted.find !== 'undefined') ?
      this.gateTargeted.find(x => x.Value === gateTargetedFormField.value) : '';
  }

  public setPrintDataPlant() {
    const plantIdFormField = this.workOrdersService.workOrderDetailsForm.get('PlantId');
    this.printFormData.Plant = (plantIdFormField && plantIdFormField.value && this.plantList &&
      this.plantList.value && typeof this.plantList.value.find !== 'undefined') ?
      this.plantList.value.find(x => x.Id === plantIdFormField.value) : '';
  }

  public setPrintDataCMEArea() {
    const cmeAreaIdFormField = this.workOrdersService.workOrderDetailsForm.get('CMEAreaId');
    this.printFormData.CMEArea = (cmeAreaIdFormField && cmeAreaIdFormField.value && this.cmeAreaList &&
      this.cmeAreaList.value && typeof this.cmeAreaList.value.find !== 'undefined') ?
      this.cmeAreaList.value.find(x => x.Id === cmeAreaIdFormField.value) : '';
  }

  public setPrintDataSMT1() {
    const smt1IdFormField = this.workOrdersService.workOrderDetailsForm.get('SMT1Id');
    this.printFormData.SMT1Description = (smt1IdFormField && smt1IdFormField.value && this.smt1List &&
      this.smt1List.value && typeof this.smt1List.value.find !== 'undefined') ?
      this.smt1List.value.find(x => x.Id === smt1IdFormField.value) : '';
  }

  public setPrintDataSMT2() {
    const smt2IdFormField = this.workOrdersService.workOrderDetailsForm.get('SMT2Id');
    this.printFormData.SMT2Description = (smt2IdFormField && smt2IdFormField.value && this.smt2List &&
      this.smt2List.value && typeof this.smt2List.value.find !== 'undefined') ?
      this.smt2List.value.find(x => x.Id === smt2IdFormField.value) : '';
  }

  public setPrintDataSMT3() {
    const smt3IdFormField = this.workOrdersService.workOrderDetailsForm.get('SMT3Id');
    this.printFormData.SMT3Description = (smt3IdFormField && smt3IdFormField.value && this.smt3List &&
      this.smt3List.value && typeof this.smt3List.value.find !== 'undefined') ?
      this.smt3List.value.find(x => x.Id === smt3IdFormField.value) : '';
  }

  public setPrintDataME() {
    const meFormField = this.workOrdersService.workOrderDetailsForm.get('ME');
    this.printFormData.ME = (meFormField && meFormField.value && this.usersList &&
      this.usersList.value && typeof this.usersList.value.find !== 'undefined') ?
      this.usersList.value.find(x => x.Gmin === meFormField.value) : '';
  }

  public setPrintDataStudyInstructions() {
    const studyInstructionsFormField = this.workOrdersService.workOrderDetailsForm.get('StudyInstructions');
    this.printFormData.StudyInstructions = (studyInstructionsFormField && studyInstructionsFormField.value) ?
      studyInstructionsFormField.value : '';
  }

  public getPrintElement(): ElementRef {
    return this.printContainerRef;
  }
}
